<template>
  <div
    class="cg-radio-group"
    :class="{ 'cg-radio-group--disabled': disabled }"
  >
    <cg-radio
      v-for="(radioData, index) in radiosData"
      :key="index"
      v-model="modelValue"
      :inputValue="radioData.inputValue"
      :disabled="isRadioItemDisabled(radioData)"
    >
      {{ radioData.defaultText }}

      <template v-if="radioData.secondaryText" #secondary-text>
        {{ radioData.secondaryText }}
      </template>
    </cg-radio>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

import type { RadioGroupItem } from '../../types';

import CgRadio from '../CgRadio';

export default Vue.extend({
  name: 'CgRadioGroup',
  components: {
    CgRadio,
  },
  props: {
    /**
     * The input’s value
     * @model
     */
    value: {
      type: String as PropType<any>,
      required: false,
      default: null,
    },
    /**
     * The radios that will be displayed
     */
    radiosData: {
      type: Array as PropType<Array<RadioGroupItem>>,
      required: true,
    },
    /**
     * Removes the ability to click or target the component.
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    lazyValue: null as any,
  }),
  computed: {
    modelValue: {
      get(): any { return this.lazyValue; },
      set(val: any) {
        this.lazyValue = val;
        /**
         * Emitted when the v-model is changed.
         * 
         * @property {any} value new value
         */
        this.$emit('input', this.lazyValue);
      }
    },
  },
  watch: {
    value (val: any) {
      this.lazyValue = val;
    },
  },
  mounted() {
    this.lazyValue = this.value;
  },
  methods: {
    isRadioItemDisabled ({ disabled }: RadioGroupItem): boolean {
      const { disabled: rootDisabled } = this
      return rootDisabled || disabled || false;
    }
  },
});
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
